import React from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";

export default function Desktop({ children }) {
  const matches = useMediaQuery("(min-device-width:1024px) and (orientation: landscape)");

  return matches ? <>{children}</> : <></>;
}
